// facciaCasuale.ts — v035b: le facce delle pagine (Home, Store, Wall of Fame, Amici, attese…) cambiano a ogni
// apertura, a caso tra tutti gli avatar (richiesta del proprietario: «che non siano prestabilite ma che cambino»).
// Mai la stessa due volte di fila. Restano fisse dove la faccia è di qualcuno (il mio avatar nel profilo e in alto a
// sinistra in Home, l'organizzatore del torneo, gli amici…). Funzione pura (provata senza React); l'aggancio
// `useFacciaCasuale` è in Faccina.tsx.
import { AVATAR_NUMERO } from "../../../condiviso/avatar.ts";

let ultima = 0;

/** Un avatar a caso (1…AVATAR_NUMERO), diverso dall'ultimo dato. `casuale` serve alle prove. */
export function facciaCasuale(casuale: () => number = Math.random): number {
  let n = 1 + Math.floor(casuale() * AVATAR_NUMERO);
  if (n > AVATAR_NUMERO) n = AVATAR_NUMERO;
  if (n === ultima) n = (n % AVATAR_NUMERO) + 1;
  ultima = n;
  return n;
}
